import '@fontsource-variable/jura';
import { RotateCcw } from 'lucide-react';
import { useEffect, useState } from 'react';
import { KanameMark } from '@/components/brand/KanameMark';
import { KanameNote } from '@/components/brand/KanameNote';
import { prefersReducedMotion } from '@/components/layout/shell/entrance';
import { cn } from '@/components/ui';
import './about.css';

/*
  «О Kaname» — мысль Максима, обыгранная на самом знаке (docs/brand-concept.md, «Канамэ: заклёпка
  и пластины»). Сначала одно ядро — заклёпка без пластин; потом по одному выходят лепестки, и веер
  раскрывается; строки манифеста проявляются по шагу. Внизу — сноска, что значит kaname. Сцена
  тёмная в обеих темах: лепестки светлые. Меньше движения в системе — всё сразу на месте.
*/

const LINES = [
  'Заклёпка без пластин — ещё не веер.',
  'Центр без сервисов — ещё не Kaname.',
  'Вместе они складываются в одно целое: каждый лепесток работает рядом с соседними — и веер раскрывается.',
];
/** Шаги рассказа, мс от начала: строка 1, строка 2, веер раскрывается, строка 3, сноска. */
const STEPS_MS = [400, 2000, 3600, 4400, 8600];

export function AboutKaname() {
  const [run, setRun] = useState(0);
  const [step, setStep] = useState(() => (prefersReducedMotion() ? STEPS_MS.length : 0));

  useEffect(() => {
    if (prefersReducedMotion()) return;
    const timers = STEPS_MS.map((ms, i) => window.setTimeout(() => setStep(i + 1), ms));
    return () => timers.forEach((t) => window.clearTimeout(t));
  }, [run]);

  /** Строка проявляется на своём шаге рассказа. */
  const shown = (at: number) => ({
    'data-about-in': step >= at || undefined,
    className: cn(step < at && 'invisible'),
  });

  return (
    <section className="flex max-w-3xl flex-col items-center gap-8 rounded-xl bg-night px-8 py-10 text-petal">
      <KanameMark open={step >= 3} tempo="slow" breathing label="Знак Kaname" className="size-40" />

      <div className="flex max-w-xl flex-col items-center gap-3 text-center">
        <p data-about-line="" {...shown(1)}>
          {LINES[0]}
        </p>
        <p data-about-line="" {...shown(2)}>
          {LINES[1]}
        </p>
        <p data-about-line="coda" {...shown(4)}>
          {LINES[2]}
        </p>
      </div>

      <KanameNote animate={step >= 5} className={cn('max-w-xl text-center', step < 5 && 'invisible')} />

      <button
        type="button"
        onClick={() => {
          setStep(0);
          setRun((r) => r + 1);
        }}
        className="inline-flex items-center gap-1.5 text-xs text-petal/60 hover:text-petal"
      >
        <RotateCcw className="size-3.5" />
        Повторить
      </button>
    </section>
  );
}
